import RfiCategoriesTable from './RfiCategoriesTable.component';

export default RfiCategoriesTable;
